import { INDIVIDUAL } from './_http';
import { queryString } from '../../helpers';

const getBesPolicyDetail = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Individual/GetPensionGeneralInfo`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getFundGraphic = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Individual/GetFundGraphic`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getFundPerformance = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Individual/GetFundPerformance`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getProgress = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Individual/GetProgressPaymentDetails?${queryString(form)}`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getIrrAndAccumulationInfo = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Individual/GetIrrAndAccumulationInfo?${queryString(form)}`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getContributionMarginInfo = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Individual/GetContributionMarginInfo`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const changeContributionMargin = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Individual/ChangeContributionMarginAsync`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getInstallments = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/Individual/GetInstallments?${queryString(form)}`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
const GetCollectingDetailInfo = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Individual/GetCollectingDetailInfo`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
const getPaymentMethods = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Individual/GetFinancialRecords`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const saveMaturitys = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Individual/SaveMaturitys`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const saveExtraContributionPayment = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Individual/SaveAdditionalContribution`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getFundDemandInfo = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Individual/GetFundDemandInfo`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const allRetirementSavings = () => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Individual/AllRetirementSavings`,{} )
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getQuestionAnswers = () => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Individual/GetQuestionAnswers`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getRrpPoint = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Individual/GetRrpPoint`,form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getReportPdf = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Individual/GetReportPdf`,form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
const saveFundDemand = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Individual/saveFundDemand`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
const getFormPdf = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Individual/Forms`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const saveFundChangeLog = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Individual/SaveFundChangeLog`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
const getOpenDates = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Individual/GetOpenDates`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
const getIgesDemandItem = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Individual/GetIgesDemandItem`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
const getListAcceptedFunds = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.get(`/AcceptedFunds/GetListAcceptedFunds?${queryString(form)}`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
const twoDatePaticipantXirr = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Appoinment/TwoDatePolicyXirrAsync`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
const getCardTypeByFirstDigits = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Individual/GetCardTypeByFirstDigits`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
const saveChangeInstrumentOfPayment = (form) => {
	return new Promise((resolve, reject) => {
		return INDIVIDUAL.post(`/Individual/SaveChangeInstrumentOfPayment`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}
export { getBesPolicyDetail, getFundGraphic, getFundPerformance, getProgress, getIrrAndAccumulationInfo, getContributionMarginInfo, changeContributionMargin, getInstallments, getPaymentMethods, saveMaturitys, saveExtraContributionPayment, saveFundDemand, getQuestionAnswers, getFundDemandInfo, getRrpPoint, allRetirementSavings, saveFundChangeLog,getReportPdf,getFormPdf, GetCollectingDetailInfo,getIgesDemandItem,getOpenDates,getListAcceptedFunds,twoDatePaticipantXirr,getCardTypeByFirstDigits,saveChangeInstrumentOfPayment }

